import {isDev} from "../functions";

export default (
    require('../otherChains/bnbTestnet').default.rpcUrls.default.http[0]
    // isDev
    //     ? require('../otherChains/bnbTestnet').default.rpcUrls.default.http[0]
    //     : 'https://bnb-testnet.likwid.fi'//'https://bnb-testnet.g.alchemy.com/v2/qupTO2ZW5SVtfWvlzUf2LsjXp_-MfgCl'
)
// 'https://white-distinguished-card.bsc-testnet.quiknode.pro/0ee0e7002caf8bd6a06e9a038cf56e2785d1a015/'